module.exports = __webpack_public_path__ + "static/img/Button_big_normal.153d389.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/Button_big_normal.png
// module id = LsCt
// module chunks = 3